import { IEnvironment } from "./IEnvironment";
import { environment as defaultEnvironment } from "./environment.default";

export const environment: IEnvironment = {
    ...defaultEnvironment,
    env: 'qa',
    clientId: 'welc6z2sYRUJPlwRg6A7WtoRE1IqqVdW',
    domain: 'login-qa.cinchhs.com',
    xApiKey: 'OHfwLZxs9Y58ZXFV4dmd4aAkyBt330JF2fFHRip8',
    footerBaseUrl: {
        ...defaultEnvironment.footerBaseUrl,
    },
    automaticDecision: {
        serviceProvider: '700001342'
    },
    ByopServiceProvider:'700001496',
    SrgOrTxSrgServiceProviders: {
       ...defaultEnvironment.SrgOrTxSrgServiceProviders
    },
    procureVendorServiceProvider: defaultEnvironment.procureVendorServiceProvider,
    roofLeakServiceProvider: defaultEnvironment.roofLeakServiceProvider,
    pazeUrl: defaultEnvironment.pazeUrl,
    pazeClient: {
        ...defaultEnvironment.pazeClient
    },
    msClarityProjectId: 'qnm1428a3z',
    hotJarProjectId: '5335614',
    cxOneGuideInitId: defaultEnvironment.cxOneGuideInitId,
    spCompeteServiceProvider: '700002184',
};
